// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file backoffice/v1/backoffice.proto (package backoffice.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BookingStatus } from "../../booking/v1/booking_pb";
import { file_booking_v1_booking } from "../../booking/v1/booking_pb";
import type { CaseStatus } from "../../case/v1/case_pb";
import { file_case_v1_case } from "../../case/v1/case_pb";
import type { Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { GuaranteeType } from "../../mission/v1/guarantee_pb";
import { file_mission_v1_guarantee } from "../../mission/v1/guarantee_pb";
import type { Price, TransportType } from "../../mobility/v1/common_pb";
import { file_mobility_v1_common } from "../../mobility/v1/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file backoffice/v1/backoffice.proto.
 */
export const file_backoffice_v1_backoffice: GenFile = /*@__PURE__*/
  fileDesc("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", [file_booking_v1_booking, file_case_v1_case, file_google_protobuf_struct, file_google_protobuf_timestamp, file_mission_v1_guarantee, file_mobility_v1_common]);

/**
 * GetMissionIndicatorsRequest - the mission to measure.
 *
 * @generated from message backoffice.v1.GetMissionIndicatorsRequest
 */
export type GetMissionIndicatorsRequest = Message<"backoffice.v1.GetMissionIndicatorsRequest"> & {
  /**
   * Mission identifier.
   *
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message backoffice.v1.GetMissionIndicatorsRequest.
 * Use `create(GetMissionIndicatorsRequestSchema)` to create a new message.
 */
export const GetMissionIndicatorsRequestSchema: GenMessage<GetMissionIndicatorsRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 0);

/**
 * GetMissionIndicatorsResponse - a mission's metrics, empty for an unknown mission. Costs are
 * external costs in EUR, as on the dashboard.
 *
 * @generated from message backoffice.v1.GetMissionIndicatorsResponse
 */
export type GetMissionIndicatorsResponse = Message<"backoffice.v1.GetMissionIndicatorsResponse"> & {
  /**
   * Distance between the origin and destination searched, as the crow flies, absent without
   * search.
   *
   * @generated from field: optional uint32 distance_meters = 1;
   */
  distanceMeters?: number;

  /**
   * External cost, absent until booked, with an unpriced item or in another currency.
   *
   * @generated from field: mobility.v1.Price external_cost = 2;
   */
  externalCost?: Price;

  /**
   * Cheapest single-taxi solution of the mission's search, absent when none was found.
   *
   * @generated from field: mobility.v1.Price direct_taxi_quote = 3;
   */
  directTaxiQuote?: Price;

  /**
   * Direct taxi quote minus the external cost, absent for a mission made by taxi only or without
   * either amount. Negative when taxi would have been cheaper.
   *
   * @generated from field: mobility.v1.Price savings_vs_taxi = 4;
   */
  savingsVsTaxi?: Price;

  /**
   * Missions created over the last 90 days in the mission's distance band, absent without
   * distance.
   *
   * @generated from field: backoffice.v1.DistanceBand band = 5;
   */
  band?: DistanceBand;
};

/**
 * Describes the message backoffice.v1.GetMissionIndicatorsResponse.
 * Use `create(GetMissionIndicatorsResponseSchema)` to create a new message.
 */
export const GetMissionIndicatorsResponseSchema: GenMessage<GetMissionIndicatorsResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 1);

/**
 * MissionSearchFilter - combinable criteria. Item criteria match a mission when one of its items
 * meets all of them at once.
 *
 * @generated from message backoffice.v1.MissionSearchFilter
 */
export type MissionSearchFilter = Message<"backoffice.v1.MissionSearchFilter"> & {
  /**
   * Exact case number.
   *
   * @generated from field: optional string case_number = 1;
   */
  caseNumber?: string;

  /**
   * Exact mission identifier.
   *
   * @generated from field: optional string mission_id = 2;
   */
  missionId?: string;

  /**
   * Beneficiary first name, case insensitive.
   *
   * @generated from field: optional string beneficiary_first_name = 3;
   */
  beneficiaryFirstName?: string;

  /**
   * Beneficiary last name, case insensitive.
   *
   * @generated from field: optional string beneficiary_last_name = 4;
   */
  beneficiaryLastName?: string;

  /**
   * Vehicle plate, case insensitive.
   *
   * @generated from field: optional string vehicle_plate = 5;
   */
  vehiclePlate?: string;

  /**
   * Beneficiary phone.
   *
   * @generated from field: optional string phone = 6;
   */
  phone?: string;

  /**
   * Missions created at or after this time.
   *
   * @generated from field: optional google.protobuf.Timestamp created_after = 7;
   */
  createdAfter?: Timestamp;

  /**
   * Missions created before this time.
   *
   * @generated from field: optional google.protobuf.Timestamp created_before = 8;
   */
  createdBefore?: Timestamp;

  /**
   * Item statuses, any of.
   *
   * @generated from field: repeated booking.v1.BookingStatus item_statuses = 9;
   */
  itemStatuses: BookingStatus[];

  /**
   * Item transport types, any of.
   *
   * @generated from field: repeated mobility.v1.TransportType transport_types = 10;
   */
  transportTypes: TransportType[];

  /**
   * Exact item provider, as listed by ListProviders.
   *
   * @generated from field: optional string provider = 11;
   */
  provider?: string;

  /**
   * Free text matched against the case number, the beneficiary's names, the vehicle plate and
   * phone (anywhere, case insensitive), and the start of the mission identifier.
   *
   * @generated from field: optional string query = 12;
   */
  query?: string;
};

/**
 * Describes the message backoffice.v1.MissionSearchFilter.
 * Use `create(MissionSearchFilterSchema)` to create a new message.
 */
export const MissionSearchFilterSchema: GenMessage<MissionSearchFilter> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 2);

/**
 * SearchMissionsRequest - a page of a mission search.
 *
 * @generated from message backoffice.v1.SearchMissionsRequest
 */
export type SearchMissionsRequest = Message<"backoffice.v1.SearchMissionsRequest"> & {
  /**
   * Cursor of the page, empty for the first one.
   *
   * @generated from field: string page_cursor = 1;
   */
  pageCursor: string;

  /**
   * Missions per page, 20 by default, 100 at most.
   *
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;

  /**
   * Search criteria.
   *
   * @generated from field: backoffice.v1.MissionSearchFilter filter = 3;
   */
  filter?: MissionSearchFilter;

  /**
   * Result order.
   *
   * @generated from field: backoffice.v1.MissionSort sort = 4;
   */
  sort: MissionSort;
};

/**
 * Describes the message backoffice.v1.SearchMissionsRequest.
 * Use `create(SearchMissionsRequestSchema)` to create a new message.
 */
export const SearchMissionsRequestSchema: GenMessage<SearchMissionsRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 3);

/**
 * SearchMissionsResponse - missions grouped by case, in result order. A case can span two pages.
 *
 * @generated from message backoffice.v1.SearchMissionsResponse
 */
export type SearchMissionsResponse = Message<"backoffice.v1.SearchMissionsResponse"> & {
  /**
   * Cases of the page with their matching missions.
   *
   * @generated from field: repeated backoffice.v1.CaseMissions cases = 1;
   */
  cases: CaseMissions[];

  /**
   * Cursor of the next page, empty on the last one.
   *
   * @generated from field: string next_page_cursor = 2;
   */
  nextPageCursor: string;
};

/**
 * Describes the message backoffice.v1.SearchMissionsResponse.
 * Use `create(SearchMissionsResponseSchema)` to create a new message.
 */
export const SearchMissionsResponseSchema: GenMessage<SearchMissionsResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 4);

/**
 * CaseMissions - a case and its missions found by a search.
 *
 * @generated from message backoffice.v1.CaseMissions
 */
export type CaseMissions = Message<"backoffice.v1.CaseMissions"> & {
  /**
   * Case identifier.
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * Case number.
   *
   * @generated from field: string case_number = 2;
   */
  caseNumber: string;

  /**
   * Case status.
   *
   * @generated from field: case.v1.CaseStatus case_status = 3;
   */
  caseStatus: CaseStatus;

  /**
   * Plate of the immobilized vehicle.
   *
   * @generated from field: string vehicle_plate = 4;
   */
  vehiclePlate: string;

  /**
   * Missions of the case found by the search.
   *
   * @generated from field: repeated backoffice.v1.MissionSummary missions = 5;
   */
  missions: MissionSummary[];
};

/**
 * Describes the message backoffice.v1.CaseMissions.
 * Use `create(CaseMissionsSchema)` to create a new message.
 */
export const CaseMissionsSchema: GenMessage<CaseMissions> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 5);

/**
 * MissionSummary - one mission of a search result.
 *
 * @generated from message backoffice.v1.MissionSummary
 */
export type MissionSummary = Message<"backoffice.v1.MissionSummary"> & {
  /**
   * Mission identifier.
   *
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * Mission creation date.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * Guarantee the mission is made under.
   *
   * @generated from field: mission.v1.GuaranteeType guarantee_type = 3;
   */
  guaranteeType: GuaranteeType;

  /**
   * Transport types of the booking items.
   *
   * @generated from field: repeated mobility.v1.TransportType transport_types = 4;
   */
  transportTypes: TransportType[];

  /**
   * ERROR as soon as one item failed, otherwise the least advanced status of the items still
   * tracked online. UNSPECIFIED when the mission has no booking.
   *
   * @generated from field: booking.v1.BookingStatus aggregated_status = 5;
   */
  aggregatedStatus: BookingStatus;

  /**
   * Sum of the item prices, absent without price or when currencies differ.
   *
   * @generated from field: mobility.v1.Price total_amount = 6;
   */
  totalAmount?: Price;

  /**
   * Number of items in error.
   *
   * @generated from field: uint32 failed_item_count = 7;
   */
  failedItemCount: number;

  /**
   * Earliest departure among the items.
   *
   * @generated from field: optional google.protobuf.Timestamp first_departure_at = 8;
   */
  firstDepartureAt?: Timestamp;
};

/**
 * Describes the message backoffice.v1.MissionSummary.
 * Use `create(MissionSummarySchema)` to create a new message.
 */
export const MissionSummarySchema: GenMessage<MissionSummary> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 6);

/**
 * ListProvidersRequest - request for the providers to filter on.
 *
 * @generated from message backoffice.v1.ListProvidersRequest
 */
export type ListProvidersRequest = Message<"backoffice.v1.ListProvidersRequest"> & {
};

/**
 * Describes the message backoffice.v1.ListProvidersRequest.
 * Use `create(ListProvidersRequestSchema)` to create a new message.
 */
export const ListProvidersRequestSchema: GenMessage<ListProvidersRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 7);

/**
 * ListProvidersResponse - providers found on booking items, sorted.
 *
 * @generated from message backoffice.v1.ListProvidersResponse
 */
export type ListProvidersResponse = Message<"backoffice.v1.ListProvidersResponse"> & {
  /**
   * Provider names.
   *
   * @generated from field: repeated string providers = 1;
   */
  providers: string[];
};

/**
 * Describes the message backoffice.v1.ListProvidersResponse.
 * Use `create(ListProvidersResponseSchema)` to create a new message.
 */
export const ListProvidersResponseSchema: GenMessage<ListProvidersResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 8);

/**
 * ListMissionAuditLogsRequest - request for the audit logs of a mission.
 *
 * @generated from message backoffice.v1.ListMissionAuditLogsRequest
 */
export type ListMissionAuditLogsRequest = Message<"backoffice.v1.ListMissionAuditLogsRequest"> & {
  /**
   * Mission identifier.
   *
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message backoffice.v1.ListMissionAuditLogsRequest.
 * Use `create(ListMissionAuditLogsRequestSchema)` to create a new message.
 */
export const ListMissionAuditLogsRequestSchema: GenMessage<ListMissionAuditLogsRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 9);

/**
 * ListMissionAuditLogsResponse - the audit logs of a mission and of its case, oldest first.
 *
 * @generated from message backoffice.v1.ListMissionAuditLogsResponse
 */
export type ListMissionAuditLogsResponse = Message<"backoffice.v1.ListMissionAuditLogsResponse"> & {
  /**
   * Audit logs.
   *
   * @generated from field: repeated backoffice.v1.AuditLog logs = 1;
   */
  logs: AuditLog[];
};

/**
 * Describes the message backoffice.v1.ListMissionAuditLogsResponse.
 * Use `create(ListMissionAuditLogsResponseSchema)` to create a new message.
 */
export const ListMissionAuditLogsResponseSchema: GenMessage<ListMissionAuditLogsResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 10);

/**
 * AuditActor - who performed an audited action.
 *
 * @generated from message backoffice.v1.AuditActor
 */
export type AuditActor = Message<"backoffice.v1.AuditActor"> & {
  /**
   * Kind of actor.
   *
   * @generated from field: backoffice.v1.AuditActorKind kind = 1;
   */
  kind: AuditActorKind;

  /**
   * User identifier, set for a user.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * User email, set for a user still known.
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * User display name, set for a user still known.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * System actor name, e.g. "taxi_webhook", set for the system.
   *
   * @generated from field: string label = 5;
   */
  label: string;
};

/**
 * Describes the message backoffice.v1.AuditActor.
 * Use `create(AuditActorSchema)` to create a new message.
 */
export const AuditActorSchema: GenMessage<AuditActor> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 11);

/**
 * AuditChange - a field's value before and after an audited action.
 *
 * @generated from message backoffice.v1.AuditChange
 */
export type AuditChange = Message<"backoffice.v1.AuditChange"> & {
  /**
   * Field name.
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * Value before, absent when the field was just set.
   *
   * @generated from field: google.protobuf.Value from = 2;
   */
  from?: Value;

  /**
   * Value after, absent when the field was cleared.
   *
   * @generated from field: google.protobuf.Value to = 3;
   */
  to?: Value;
};

/**
 * Describes the message backoffice.v1.AuditChange.
 * Use `create(AuditChangeSchema)` to create a new message.
 */
export const AuditChangeSchema: GenMessage<AuditChange> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 12);

/**
 * AuditLog - one action performed in the app.
 *
 * @generated from message backoffice.v1.AuditLog
 */
export type AuditLog = Message<"backoffice.v1.AuditLog"> & {
  /**
   * Audit log identifier.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * When the action happened.
   *
   * @generated from field: google.protobuf.Timestamp occurred_at = 2;
   */
  occurredAt?: Timestamp;

  /**
   * Who performed it.
   *
   * @generated from field: backoffice.v1.AuditActor actor = 3;
   */
  actor?: AuditActor;

  /**
   * Action name, e.g. "mission.created", "booking.confirmed".
   *
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * Type of the entity acted on: "case", "mission", "booking" or "booking_item".
   *
   * @generated from field: string entity_type = 5;
   */
  entityType: string;

  /**
   * Identifier of the entity acted on.
   *
   * @generated from field: string entity_id = 6;
   */
  entityId: string;

  /**
   * Fields the action set or changed.
   *
   * @generated from field: repeated backoffice.v1.AuditChange changes = 7;
   */
  changes: AuditChange[];

  /**
   * Why the action was performed, when given.
   *
   * @generated from field: string reason = 8;
   */
  reason: string;

  /**
   * Request that performed the action, to find it in the logs.
   *
   * @generated from field: string request_id = 9;
   */
  requestId: string;
};

/**
 * Describes the message backoffice.v1.AuditLog.
 * Use `create(AuditLogSchema)` to create a new message.
 */
export const AuditLogSchema: GenMessage<AuditLog> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 13);

/**
 * GetDashboardRequest - the period of the dashboard, on mission creation date.
 *
 * @generated from message backoffice.v1.GetDashboardRequest
 */
export type GetDashboardRequest = Message<"backoffice.v1.GetDashboardRequest"> & {
  /**
   * Missions created at or after this time, since the first one when absent.
   *
   * @generated from field: optional google.protobuf.Timestamp created_after = 1;
   */
  createdAfter?: Timestamp;

  /**
   * Missions created before this time, up to now when absent.
   *
   * @generated from field: optional google.protobuf.Timestamp created_before = 2;
   */
  createdBefore?: Timestamp;
};

/**
 * Describes the message backoffice.v1.GetDashboardRequest.
 * Use `create(GetDashboardRequestSchema)` to create a new message.
 */
export const GetDashboardRequestSchema: GenMessage<GetDashboardRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 14);

/**
 * GetDashboardResponse - business metrics of the missions created over the period. Costs are
 * external costs: the price of the items booked with providers, in EUR, missions booked in another
 * currency or with an unpriced item left out.
 *
 * @generated from message backoffice.v1.GetDashboardResponse
 */
export type GetDashboardResponse = Message<"backoffice.v1.GetDashboardResponse"> & {
  /**
   * Volumes of the period.
   *
   * @generated from field: backoffice.v1.DashboardTotals totals = 1;
   */
  totals?: DashboardTotals;

  /**
   * Time from mission creation to booking confirmation, in seconds.
   *
   * @generated from field: backoffice.v1.Distribution handling_time = 2;
   */
  handlingTime?: Distribution;

  /**
   * External cost of a booked mission, in minor units.
   *
   * @generated from field: backoffice.v1.Distribution external_cost = 3;
   */
  externalCost?: Distribution;

  /**
   * Metrics by mission distance, as the crow flies, shortest first.
   *
   * @generated from field: repeated backoffice.v1.DistanceBand distance_bands = 4;
   */
  distanceBands: DistanceBand[];

  /**
   * External cost of booked missions by creation week or month, over the whole period.
   *
   * @generated from field: backoffice.v1.CostTrend external_cost_trend = 5;
   */
  externalCostTrend?: CostTrend;
};

/**
 * Describes the message backoffice.v1.GetDashboardResponse.
 * Use `create(GetDashboardResponseSchema)` to create a new message.
 */
export const GetDashboardResponseSchema: GenMessage<GetDashboardResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 15);

/**
 * CostTrend - median external cost by period: weekly up to 92 days, monthly beyond.
 *
 * @generated from message backoffice.v1.CostTrend
 */
export type CostTrend = Message<"backoffice.v1.CostTrend"> & {
  /**
   * Length of the points' periods.
   *
   * @generated from field: backoffice.v1.TrendGranularity granularity = 1;
   */
  granularity: TrendGranularity;

  /**
   * Every period of the dashboard, oldest first, empty ones included.
   *
   * @generated from field: repeated backoffice.v1.TrendPoint points = 2;
   */
  points: TrendPoint[];
};

/**
 * Describes the message backoffice.v1.CostTrend.
 * Use `create(CostTrendSchema)` to create a new message.
 */
export const CostTrendSchema: GenMessage<CostTrend> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 16);

/**
 * TrendPoint - the costed missions created in one period of a trend.
 *
 * @generated from message backoffice.v1.TrendPoint
 */
export type TrendPoint = Message<"backoffice.v1.TrendPoint"> & {
  /**
   * Start of the period.
   *
   * @generated from field: google.protobuf.Timestamp start = 1;
   */
  start?: Timestamp;

  /**
   * Costed missions created in the period.
   *
   * @generated from field: uint32 missions = 2;
   */
  missions: number;

  /**
   * Median external cost, absent without mission.
   *
   * @generated from field: mobility.v1.Price median_cost = 3;
   */
  medianCost?: Price;

  /**
   * 25th percentile of the external cost, absent without mission.
   *
   * @generated from field: mobility.v1.Price p25_cost = 4;
   */
  p25Cost?: Price;

  /**
   * 75th percentile of the external cost, absent without mission.
   *
   * @generated from field: mobility.v1.Price p75_cost = 5;
   */
  p75Cost?: Price;
};

/**
 * Describes the message backoffice.v1.TrendPoint.
 * Use `create(TrendPointSchema)` to create a new message.
 */
export const TrendPointSchema: GenMessage<TrendPoint> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 17);

/**
 * DashboardTotals - volumes of a dashboard period.
 *
 * @generated from message backoffice.v1.DashboardTotals
 */
export type DashboardTotals = Message<"backoffice.v1.DashboardTotals"> & {
  /**
   * Missions created.
   *
   * @generated from field: uint32 created_missions = 1;
   */
  createdMissions: number;

  /**
   * Missions with at least one item booked.
   *
   * @generated from field: uint32 booked_missions = 2;
   */
  bookedMissions: number;

  /**
   * Missions with at least one item in error.
   *
   * @generated from field: uint32 failed_missions = 3;
   */
  failedMissions: number;

  /**
   * Sum of the external costs of the booked missions.
   *
   * @generated from field: mobility.v1.Price total_external_cost = 4;
   */
  totalExternalCost?: Price;
};

/**
 * Describes the message backoffice.v1.DashboardTotals.
 * Use `create(DashboardTotalsSchema)` to create a new message.
 */
export const DashboardTotalsSchema: GenMessage<DashboardTotals> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 18);

/**
 * Distribution - spread of a metric over missions, in the metric's unit.
 *
 * @generated from message backoffice.v1.Distribution
 */
export type Distribution = Message<"backoffice.v1.Distribution"> & {
  /**
   * Missions measured.
   *
   * @generated from field: uint32 count = 1;
   */
  count: number;

  /**
   * 5th percentile.
   *
   * @generated from field: double p5 = 2;
   */
  p5: number;

  /**
   * Median.
   *
   * @generated from field: double p50 = 3;
   */
  p50: number;

  /**
   * 95th percentile.
   *
   * @generated from field: double p95 = 4;
   */
  p95: number;

  /**
   * 25th percentile.
   *
   * @generated from field: double p25 = 6;
   */
  p25: number;

  /**
   * 75th percentile.
   *
   * @generated from field: double p75 = 7;
   */
  p75: number;

  /**
   * The missions measured, lowest first: all of them up to 300, else 300 of them evenly spread
   * over their ranks.
   *
   * @generated from field: repeated backoffice.v1.MissionValue points = 8;
   */
  points: MissionValue[];

  /**
   * Whether points lists every mission measured.
   *
   * @generated from field: bool points_complete = 9;
   */
  pointsComplete: boolean;
};

/**
 * Describes the message backoffice.v1.Distribution.
 * Use `create(DistributionSchema)` to create a new message.
 */
export const DistributionSchema: GenMessage<Distribution> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 19);

/**
 * MissionValue - one mission's measure in a distribution.
 *
 * @generated from message backoffice.v1.MissionValue
 */
export type MissionValue = Message<"backoffice.v1.MissionValue"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * Creation of the mission.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * The measure, in the distribution's unit.
   *
   * @generated from field: double value = 3;
   */
  value: number;
};

/**
 * Describes the message backoffice.v1.MissionValue.
 * Use `create(MissionValueSchema)` to create a new message.
 */
export const MissionValueSchema: GenMessage<MissionValue> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 20);

/**
 * ModeCount - booked missions of a mode.
 *
 * @generated from message backoffice.v1.ModeCount
 */
export type ModeCount = Message<"backoffice.v1.ModeCount"> & {
  /**
   * Mode.
   *
   * @generated from field: backoffice.v1.MissionMode mode = 1;
   */
  mode: MissionMode;

  /**
   * Missions booked with it.
   *
   * @generated from field: uint32 missions = 2;
   */
  missions: number;
};

/**
 * Describes the message backoffice.v1.ModeCount.
 * Use `create(ModeCountSchema)` to create a new message.
 */
export const ModeCountSchema: GenMessage<ModeCount> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 21);

/**
 * DistanceBand - metrics of the booked missions whose distance falls in [min_km, max_km).
 *
 * @generated from message backoffice.v1.DistanceBand
 */
export type DistanceBand = Message<"backoffice.v1.DistanceBand"> & {
  /**
   * Lower bound in kilometers, included.
   *
   * @generated from field: uint32 min_km = 1;
   */
  minKm: number;

  /**
   * Upper bound in kilometers, excluded, absent for the last band.
   *
   * @generated from field: optional uint32 max_km = 2;
   */
  maxKm?: number;

  /**
   * Booked missions of the band.
   *
   * @generated from field: uint32 booked_missions = 3;
   */
  bookedMissions: number;

  /**
   * Booked missions by mode, most used first.
   *
   * @generated from field: repeated backoffice.v1.ModeCount modes = 4;
   */
  modes: ModeCount[];

  /**
   * Median external cost of a mission, absent without costed mission.
   *
   * @generated from field: mobility.v1.Price median_external_cost = 5;
   */
  medianExternalCost?: Price;

  /**
   * Sum of the external costs.
   *
   * @generated from field: mobility.v1.Price total_external_cost = 6;
   */
  totalExternalCost?: Price;

  /**
   * Share of the booked missions not made by taxi only, from 0 to 1.
   *
   * @generated from field: double modal_shift_rate = 7;
   */
  modalShiftRate: number;

  /**
   * Direct taxi quotes minus the external costs, over the missions not made by taxi only whose
   * search returned a direct taxi quote. Negative when taxi would have been cheaper.
   *
   * @generated from field: mobility.v1.Price savings_vs_taxi = 8;
   */
  savingsVsTaxi?: Price;

  /**
   * Missions the savings are computed on.
   *
   * @generated from field: uint32 savings_missions = 9;
   */
  savingsMissions: number;
};

/**
 * Describes the message backoffice.v1.DistanceBand.
 * Use `create(DistanceBandSchema)` to create a new message.
 */
export const DistanceBandSchema: GenMessage<DistanceBand> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 22);

/**
 * MissionSort - order of a mission search, newest first.
 *
 * @generated from enum backoffice.v1.MissionSort
 */
export enum MissionSort {
  /**
   * Defaults to MISSION_SORT_CREATED_AT_DESC.
   *
   * @generated from enum value: MISSION_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * By mission creation date.
   *
   * @generated from enum value: MISSION_SORT_CREATED_AT_DESC = 1;
   */
  CREATED_AT_DESC = 1,

  /**
   * By first departure of the mission's items; missions without departure come last.
   *
   * @generated from enum value: MISSION_SORT_FIRST_DEPARTURE_DESC = 2;
   */
  FIRST_DEPARTURE_DESC = 2,
}

/**
 * Describes the enum backoffice.v1.MissionSort.
 */
export const MissionSortSchema: GenEnum<MissionSort> = /*@__PURE__*/
  enumDesc(file_backoffice_v1_backoffice, 0);

/**
 * AuditActorKind - who performed an audited action.
 *
 * @generated from enum backoffice.v1.AuditActorKind
 */
export enum AuditActorKind {
  /**
   * @generated from enum value: AUDIT_ACTOR_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A signed-in user.
   *
   * @generated from enum value: AUDIT_ACTOR_KIND_USER = 1;
   */
  USER = 1,

  /**
   * The system acting on its own: a provider webhook, a background job.
   *
   * @generated from enum value: AUDIT_ACTOR_KIND_SYSTEM = 2;
   */
  SYSTEM = 2,
}

/**
 * Describes the enum backoffice.v1.AuditActorKind.
 */
export const AuditActorKindSchema: GenEnum<AuditActorKind> = /*@__PURE__*/
  enumDesc(file_backoffice_v1_backoffice, 1);

/**
 * TrendGranularity - length of the periods a trend is split into.
 *
 * @generated from enum backoffice.v1.TrendGranularity
 */
export enum TrendGranularity {
  /**
   * @generated from enum value: TREND_GRANULARITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Weeks starting on Monday, Paris time.
   *
   * @generated from enum value: TREND_GRANULARITY_WEEK = 1;
   */
  WEEK = 1,

  /**
   * Calendar months, Paris time.
   *
   * @generated from enum value: TREND_GRANULARITY_MONTH = 2;
   */
  MONTH = 2,
}

/**
 * Describes the enum backoffice.v1.TrendGranularity.
 */
export const TrendGranularitySchema: GenEnum<TrendGranularity> = /*@__PURE__*/
  enumDesc(file_backoffice_v1_backoffice, 2);

/**
 * MissionMode - the transports a mission was booked with.
 *
 * @generated from enum backoffice.v1.MissionMode
 */
export enum MissionMode {
  /**
   * @generated from enum value: MISSION_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Taxi only.
   *
   * @generated from enum value: MISSION_MODE_TAXI = 1;
   */
  TAXI = 1,

  /**
   * Train only.
   *
   * @generated from enum value: MISSION_MODE_TRAIN = 2;
   */
  TRAIN = 2,

  /**
   * Train with taxi ground transfers.
   *
   * @generated from enum value: MISSION_MODE_TRAIN_TAXI = 3;
   */
  TRAIN_TAXI = 3,

  /**
   * A rental vehicle, alone or with other transports.
   *
   * @generated from enum value: MISSION_MODE_RENTAL = 4;
   */
  RENTAL = 4,
}

/**
 * Describes the enum backoffice.v1.MissionMode.
 */
export const MissionModeSchema: GenEnum<MissionMode> = /*@__PURE__*/
  enumDesc(file_backoffice_v1_backoffice, 3);

/**
 * BackofficeService - supervision and support tools for The Treep staff. Every procedure of this
 * package is refused to users who are not platform users.
 *
 * @generated from service backoffice.v1.BackofficeService
 */
export const BackofficeService: GenService<{
  /**
   * Searches missions on their case and on their booking items, grouped by case.
   *
   * @generated from rpc backoffice.v1.BackofficeService.SearchMissions
   */
  searchMissions: {
    methodKind: "unary";
    input: typeof SearchMissionsRequestSchema;
    output: typeof SearchMissionsResponseSchema;
  },
  /**
   * Lists the providers found on booking items, to filter missions on.
   *
   * @generated from rpc backoffice.v1.BackofficeService.ListProviders
   */
  listProviders: {
    methodKind: "unary";
    input: typeof ListProvidersRequestSchema;
    output: typeof ListProvidersResponseSchema;
  },
  /**
   * Lists what was done on a mission and on its case, and by whom, oldest first.
   *
   * @generated from rpc backoffice.v1.BackofficeService.ListMissionAuditLogs
   */
  listMissionAuditLogs: {
    methodKind: "unary";
    input: typeof ListMissionAuditLogsRequestSchema;
    output: typeof ListMissionAuditLogsResponseSchema;
  },
  /**
   * Business metrics of the missions created over a period.
   *
   * @generated from rpc backoffice.v1.BackofficeService.GetDashboard
   */
  getDashboard: {
    methodKind: "unary";
    input: typeof GetDashboardRequestSchema;
    output: typeof GetDashboardResponseSchema;
  },
  /**
   * A mission's metrics placed against the dashboard ones.
   *
   * @generated from rpc backoffice.v1.BackofficeService.GetMissionIndicators
   */
  getMissionIndicators: {
    methodKind: "unary";
    input: typeof GetMissionIndicatorsRequestSchema;
    output: typeof GetMissionIndicatorsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_backoffice_v1_backoffice, 0);

